import React from 'react';
import { connect } from 'react-redux';

import { setFilterAttribute } from 'bundles/connect/components/store/actions/criteria';
import Toggle from './toggle';
import type { Criteria } from 'bundles/connect/types';

type OnMarketDurationToggleProps = {
  bordered?: boolean;
  criteria: Criteria;
  setFilterAttribute: (key: string, value: any) => void;
}

function OnMarketDurationToggle({
  bordered = false,
  criteria,
  setFilterAttribute
}: OnMarketDurationToggleProps) {
  const controlClicked = () => {
    setFilterAttribute('onMarketDuration', !criteria.onMarketDuration ? 'weeks1' : undefined);
  };

  return (
    <Toggle
      bordered={bordered}
      checked={!!criteria.onMarketDuration}
      label="New Listings Only"
      onClick={controlClicked}
    />
  );
}

const mapStateToProps = ({ criteria }) => ({ criteria });

export default connect(mapStateToProps, { setFilterAttribute })(OnMarketDurationToggle);
